import React, { Fragment, useState } from 'react';
import Popover from 'material-ui/Popover';
import * as PropTypes from 'prop-types';

import SimpleMenuItem from './SimpleItem';

function ComplexMenuItem({ onClick, submenu, ...rest }) {
  const [anchorEl, setAnchorEl] = useState();
  const openSubMenu = event => setAnchorEl(event.currentTarget);
  const closeSubMenu = () => setAnchorEl(null);
  const isOpen = Boolean(anchorEl);

  const handleSubmenuClick = (item, e) => {
    closeSubMenu();
    onClick(e);
    submenu.onClick(item);
  };

  return (
    <Fragment>
      <SimpleMenuItem {...rest} onClick={openSubMenu} />

      <Popover
        className="popover"
        open={isOpen}
        anchorOrigin={submenu.position}
        anchorEl={anchorEl}
        onClose={closeSubMenu}
      >
        {submenu.list.map((item, i) => (
          <SimpleMenuItem
            onClick={e => handleSubmenuClick(item, e)}
            key={item.id}
            {...item}
          />
        ))}
      </Popover>
    </Fragment>
  );
}

ComplexMenuItem.propTypes = {
  onClick: PropTypes.func,
  submenu: PropTypes.object,
};

export default ComplexMenuItem;



// WEBPACK FOOTER //
// ./src/components/common/IconMenu/MenuItem/ComplexItem.jsx